import axios from "axios";
import {randomString} from "./func.ts";

let tus ;
const loadTusClient = async ()=>{
    await import('tus-js-client')
        .then((module)=>{
            tus = module
        })
}

export const baseURL = import.meta.env.PROD ?
    `https://api.timelyturtle.com` : `http://5.9.121.86:81`
let access_token = localStorage.getItem('access_token')
const client = axios.create({
    baseURL: baseURL,
    headers: access_token ? {
        'Authorization':`Bearer ${access_token}`
    } : undefined
})
export function getHttpClient(){
    const headers = {
        baseURL: baseURL,
        headers: localStorage.access_token  ? {
            'Authorization':`Bearer ${localStorage.access_token}`
        } : undefined
    }
    return axios.create(headers)
}
export async function swrFetcher(url: string){
    return getHttpClient().get(url).then(({data})=>data)
}
export async function withoutAuthFetcher(url: string){
    const client = axios.create({
        baseURL: baseURL,
        headers: access_token ? {
            'Authorization':`Bearer ${access_token}`
        } : undefined
    })
    return client.get(url).then(({data})=>data)
}



export function setAccessToken(accessToken: string | null){
    access_token = accessToken;
    if(accessToken) {
        localStorage.setItem('access_token', accessToken || '')
    }else{
        localStorage.removeItem('access_token');
    }
}

export interface UploadedImageAsset {
    url: string;
    mimetype: string;
    name: string;
}
export interface UploadedVideoAsset {
    thumbnail: string;
    libraryId: string;
    videoId: string;
    mimetype: string;
    url: string;
    name: string;
}

export type  UploadedAsset = UploadedImageAsset | UploadedVideoAsset

function getExtension(mimeType?: string){
    if(mimeType?.includes('video')){
        return ".mp4"
    }else{
        return ".jpg"
    }
}

export async function uploadFile(file: File, id?: string): Promise<UploadedAsset>{
    if(file.type.includes("video")){
        return tusUpload(file, id)
    }else{
        return uploadImageFile(file, (progress)=>{
            if(id) {
                dispatchProgressEvent(id, progress)
            }
        })
    }
}

function dispatchProgressEvent(id: string, data: ProgressCallbackInput){
    window.dispatchEvent(new CustomEvent("media-upload-progress", {
        detail: {
            id,
            data,
        }
    }))
}

interface ProgressCallbackInput{
    progress: number,
    bytesUploaded: number,
    bytesTotal: number
}

export async function uploadImageFile(
    file: File,
    progressCallback?: (input:ProgressCallbackInput) => void,
    abortController?: AbortController,
): Promise<UploadedImageAsset> {
    const client = getHttpClient()
    const filename = // file.fileName || // filename can't be used because facebook doesn't like spaces in the filename
        randomString()+getExtension(file.type);
    // get pre signed post
    const {url, fields} = await client.post(
        '/assets/preSignedUrl',
        {
            filename
        }).then(({data}) => data);
    console.log('got', url, fields)
    const formData = new FormData();
    Object.keys(fields).forEach((key) => {
        formData.append(key, fields[key]);
    });
    formData.append('Content-Type', file.type);
    formData.append('file', file);
    await axios.post(url, formData, {
        //https://github.com/axios/axios/issues/5366
        //https://github.com/axios/axios/issues/5366#issuecomment-1420052291
        headers: {
            'content-type': 'multipart/form-data',
        },
        signal: abortController?.signal,
        onUploadProgress: progressCallback
            ? (event) => {
                if (event.total) {
                    progressCallback({
                        progress:
                        Math.round((event.loaded / event.total) * 100),
                        bytesUploaded: event.loaded,
                        bytesTotal: event.total
                    });
                }
            }
            : undefined,
    });
    const uri = `https://media.goaffpro.com/${fields.key}`;
    return {
        // key: fields.key,
        url: uri,
        mimetype: file.type,
        name: filename
    };
}
export async function saveAsset(item: UploadedAsset, {thumbnail, width, height, parent_id, type}:{
    parent_id: number,
    thumbnail: string;
    width: number,
    height: number,
    type: string
}): Promise<{id:string}>{
    return client.post('/assets', {
        parent_id,
        data: {
            ...item,
            thumbnail,
            width, height,
        },
        type
    })
    .then(({data})=>data)

}


export async function uploadThumbnailBlob(
    file: Blob,
    progressCallback?: (progress: number) => void,
    abortController?: AbortController,
): Promise<UploadedAsset> {
    const client = getHttpClient()
    const filename = "thumbnail.png";

    // get pre signed post
    const {url, fields} = await client.post(
        '/assets/preSignedUrl',
        {
            filename
        }).then(({data}) => data);
    console.log('got', url, fields)
    const formData = new FormData();
    Object.keys(fields).forEach((key) => {
        formData.append(key, fields[key]);
    });
    formData.append('Content-Type', "image/png");
    formData.append('file', file, filename);
    await axios.post(url, formData, {
        //https://github.com/axios/axios/issues/5366
        //https://github.com/axios/axios/issues/5366#issuecomment-1420052291
        headers: {
            'content-type': 'multipart/form-data',
        },
        signal: abortController?.signal,
        onUploadProgress: progressCallback
            ? (event) => {
                if (event.total) {
                    progressCallback(Math.round((event.loaded / event.total) * 100));
                }
            }
            : undefined,
    });
    const uri = `https://media.goaffpro.com/${fields.key}`;
    return {
        // key: fields.key,
        url: uri,
        mimetype: file.type,
        name: filename
    };
}
export async function tusUpload(file: File, id?: string): Promise<UploadedVideoAsset>{
    const client = getHttpClient()
    await loadTusClient()
    const filename = file.name || randomString()+getExtension(file.type);
    const {
        tusHeaders,
        videoURL,
        thumbnail,
        mimetype,
        videoId,
        // hlsURL,
        // playURL,
        libraryId
    } = await client.post('/assets/bunnyUploadStreamTus',{
        filename
    }).then(({data})=>data)
// Create a new tus upload
    return new Promise((resolve, reject)=>{
        const upload = new tus.Upload(file || file, {
            endpoint: "https://video.bunnycdn.com/tusupload",
            retryDelays: [0, 3000, 5000, 10000, 20000, 60000, 60000],
            headers:tusHeaders,
            metadata: {
                filetype: file.type,
                title: file.name,
                collection:'cc39cc1b-cc8a-49ba-9efb-39f5220ec50d',
            },
            onError: function (error) {
                console.log('got error')
                console.log(error);
                reject(error)
            },
            onProgress: function (bytesUploaded, bytesTotal) {
                if(id) {
                    dispatchProgressEvent(id, {
                        progress: Math.round((bytesUploaded / bytesTotal) * 100),
                        bytesUploaded,
                        bytesTotal
                    })
                }
            },
            onSuccess: function () {
                resolve({
                    url:videoURL,
                    thumbnail,
                    // hlsURL,
                    // playURL,
                    mimetype,
                    videoId,
                    libraryId,
                    name: filename,
                })
                console.log('success')
            }
        })

// Check if there are any previous uploads to continue.
        upload.findPreviousUploads().then(function (previousUploads) {
            console.log('previousUploads', previousUploads)
            // Found previous uploads so we select the first one.
            if (previousUploads.length) {
                upload.resumeFromPreviousUpload(previousUploads[0])
            }
            // Start the upload
            upload.start()
        })
    })
}
